package com.clany.backoffice.data.network

import io.ktor.http.Parameters
import io.ktor.http.formUrlEncode

object AuthBodyCalls {
    fun accessTokenBody(username: String, password: String, clientId: String) = Parameters.build {
        append("username", username)
        append("password", password)
        append("grant_type", "password")
        append("client_id", clientId)
    }.formUrlEncode()

    fun refreshTokenBody(refreshToken: String, clientId: String) = Parameters.build {
        append("refresh_token", refreshToken)
        append("grant_type", "refresh_token")
        append("client_id", clientId)
    }.formUrlEncode()

    fun authCodeExchangeBody(
        code: String,
        clientId: String,
        redirectUri: String,
        codeVerifier: String
    ) = Parameters.build {
        append("grant_type", "authorization_code")
        append("code", code)
        append("client_id", clientId)
        append("redirect_uri", redirectUri)
        append("code_verifier", codeVerifier)
    }.formUrlEncode()
}
